// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachment-table-action-wrapper {
  display: flex;
  justify-content: space-evenly;
}

.pagination-wrapper {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
}
.pagination-wrapper .pagination-footer {
  margin-left: 20px;
}

.uploaded-files-title-wrapper {
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.file-drop-wrapper {
  width: 100%;
  height: 175px;
  border: 2px dashed rgb(204, 204, 204);
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-content: space-around;
  justify-content: space-evenly;
  flex-wrap: wrap;
}

.file-drop-wrapper:hover {
  border: 2px dashed #aaccf8;
}
.file-drop-wrapper:hover .upload-icon:before {
  transform: translate(-54%, -68%);
  transition: transform 0.2s ease-in-out;
}
.file-drop-wrapper:hover .upload-icon {
  transform: scale(1.2);
}

.upload-icon {
  margin-top: 10px;
  position: relative;
  display: flex;
  justify-content: space-around;
  color: #5fcde2;
  height: 50px;
}

.upload-icon::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-53%, -67%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #5fcde2;
  background-color: #5fcde2;
  opacity: 0.2;
  box-sizing: border-box;
}

.upload-icon > * {
  position: relative;
  z-index: 1;
}

.upload-text {
  text-align: center;
}

.file-drop-max-size-text {
  color: #adb5bd;
}

.uploaded-files-wrapper .invalid-form {
  color: #ca1820;
}

.uploaded-file-item {
  width: 100%;
  padding: 5px;
  background-color: rgba(233, 236, 239, 0.6);
}

.uploaded-file-icon {
  font-size: 35px;
  color: #ca1820;
}

.trash-file-icon {
  font-size: 20px;
  color: #343a40;
  margin-right: 10px;
}

.trash-file-icon:hover {
  transform: scale(1.4);
  transition: transform 0.15s ease-in-out;
  color: #adb5bd;
}

.center-icon {
  display: grid;
  align-content: center;
  justify-content: center;
}

.x-icon {
  position: absolute;
  right: 40px;
  bottom: 7px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 1em;
}

.is-invalid {
  border-color: #ca1820;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/file-upload/file-upload.scss","webpack://./node_modules/edozvola-frontend-lib/dist/assets/css/00-settings/_colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,6BAAA;AADF;;AAIA;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;AADF;AAGE;EACE,iBAAA;AADJ;;AAKA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;;AAKA;EACE,WAAA;EACA,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,6BAAA;EACA,eAAA;AAFF;;AAKA;EACE,0BAAA;AAFF;AAGE;EACE,gCAAA;EACA,sCAAA;AADJ;AAGE;EACE,qBAAA;AADJ;;AAKA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,cCtCW;EDuCX,YAAA;AAFF;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBCpDW;EDqDX,YAAA;EACA,sBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,UAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,cC1DK;ADwDP;;AAME;EACE,cC/EE;AD4EN;;AAOA;EACE,WAAA;EACA,YAAA;EACA,0CCrEW;ADiEb;;AAOA;EACE,eAAA;EACA,cC3FI;ADuFN;;AAOA;EACE,eAAA;EACA,cCtGU;EDuGV,kBAAA;AAJF;;AAMA;EACE,qBAAA;EACA,uCAAA;EACA,cCtFK;ADmFP;;AAMA;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;AAHF;;AAMA;EACE,qBCxHI;ADqHN","sourcesContent":["@import 'edozvola-frontend-lib/dist/assets/css/00-settings/colors';\n\n.attachment-table-action-wrapper {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.pagination-wrapper {\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-end;\n\n  .pagination-footer {\n    margin-left: 20px;\n  }\n}\n\n.uploaded-files-title-wrapper {\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.file-drop-wrapper {\n  width: 100%;\n  height: 175px;\n  border: 2px dashed rgb(204, 204, 204);\n  border-radius: 10px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-content: space-around;\n  justify-content: space-evenly;\n  flex-wrap: wrap;\n}\n\n.file-drop-wrapper:hover {\n  border: 2px dashed $primary-lightest;\n  .upload-icon:before {\n    transform: translate(-54%, -68%);\n    transition: transform 0.2s ease-in-out;\n  }\n  .upload-icon {\n    transform: scale(1.2);\n  }\n}\n\n.upload-icon {\n  margin-top: 10px;\n  position: relative;\n  display: flex;\n  justify-content: space-around;\n  color: $blue-light;\n  height: 50px;\n}\n\n.upload-icon::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-53%, -67%);\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  border: 2px solid $blue-light;\n  background-color: $blue-light;\n  opacity: 0.2;\n  box-sizing: border-box;\n}\n\n.upload-icon > * {\n  position: relative;\n  z-index: 1;\n}\n\n.upload-text {\n  text-align: center;\n}\n\n.file-drop-max-size-text {\n  color: $gray;\n}\n\n.uploaded-files-wrapper {\n  .invalid-form {\n    color: $red;\n  }\n}\n\n.uploaded-file-item {\n  width: 100%;\n  padding: 5px;\n  background-color: $gray-light;\n}\n\n.uploaded-file-icon {\n  font-size: 35px;\n  color: $red;\n}\n\n.trash-file-icon {\n  font-size: 20px;\n  color: $secondary;\n  margin-right: 10px;\n}\n.trash-file-icon:hover {\n  transform: scale(1.4);\n  transition: transform 0.15s ease-in-out;\n  color: $gray;\n}\n\n.center-icon {\n  display: grid;\n  align-content: center;\n  justify-content: center;\n}\n\n.x-icon {\n  position: absolute;\n  right: 40px;\n  bottom: 7px;\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 1em;\n}\n\n.is-invalid {\n  border-color: $red;\n}\n","// Main colors\n$primary: #3a516e;\n$secondary: #343a40;\n\n// Misc Colors\n$green: #17aa55;\n$green-light: #88dda9;\n\n$red: #ca1820;\n$red-light: #d85b61;\n$red-lighter: #e9a7a9;\n$red-lightest: #f4d3d4;\n$yellow: #ffce00;\n\n$blue: #199cb4;\n$blue-light: #5fcde2;\n\n$primary-lighter: #607a9b;\n$primary-lightest: #aaccf8;\n\n$black: #000000;\n$white: #fff;\n\n$gray-dark: #828a90;\n$gray: #adb5bd;\n$gray-light: rgba(233, 236, 239, 0.6);\n$gray-lighter: #f4f5f7;\n\n// Alerts colors\n$success: #19b45a;\n$info: $blue;\n$warning: #f5d8d9;\n$danger: $primary;\n$default: $gray;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
